import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export function usePlanAddPaymentMethod() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  interface IntentData {
    clientSecret: string;
  }

  interface PaymentData {
    paymentMethodId: string;
    subscriptionId: string;
  }

  return useMutation({
    mutationFn: async (paymentData: PaymentData): Promise<IntentData> => {

      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/add_payment_method`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: JSON.stringify(paymentData),
        }
      );
      const data = await response.json();

      const { clientSecret } = data?.data;

      return {
        clientSecret: clientSecret
      };
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['userPaymentMethods']);
    },
  });
}